import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild  {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // return true; for debug
        if (sessionStorage.getItem('currentUser')) {
            // logged in so return true
            return true;
        }
       
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/welcome'], { queryParams: { returnUrl: state.url } });
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // return true; for debug
        if (sessionStorage.getItem('currentUser')) {
            // logged in so return true
            return true;
        }
        
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/welcome'], { queryParams: { returnUrl: state.url } });
        return false;
      }
}
